<div class="container-tab uploaded-file-tab">
  <form #form="ngForm" class="form-container pt-4">
    @if (playlistItem.TimerConfig) {
      <div class="form-group row no-gutters invisible-border">
        <label for="TimerType" class="col-md-3" matTooltip="Playlist item timer type">Timer Type</label>
        <div class="toggle-container col-md-5 p-0">
          <mat-button-toggle-group
            id="TimerType"
            name="TimerType"
            class="toggle-group"
            [(ngModel)]="playlistItem.TimerConfig.TimerType"
            (change)="onTypeChange()">
              <mat-button-toggle [value]="timerTypes.Clock">
                Clock
              </mat-button-toggle>
              <mat-button-toggle [value]="timerTypes.Timer">
                Timer
              </mat-button-toggle>
          </mat-button-toggle-group>

          <mat-icon class="settings" svgIcon="setting" matTooltip="Configure Timer" (click)="onConfigureTimer()"></mat-icon>
        </div>
      </div>

      @if (playlistItem.TimerConfig.TimerType === timerTypes.Timer) {
        <div class="form-group row no-gutters">
          <label for="Duration" class="col-md-3" matTooltip="Timer item interval">Set Timer Interval</label>
          <div class="col-md-5 invisible-border duration-wrapper">
            <duration-picker [(duration)]="playlistItem.TimerConfig.TimerInterval" tooltip="Change timer interval"></duration-picker>
          </div>
        </div>
      }
    }
  </form>

  <mat-toolbar class="tab-footer unset">
    @if (!playlistItem.Id) {
      <mat-checkbox [disableRipple]="true" [(ngModel)]="addAnother" name="addAnother"
        class="light" matTooltip="Add one more item to the Playlist">Add Another</mat-checkbox>
    }
    <button type="button" mat-raised-button (click)="cancel.emit()" mat-flat-button matTooltip="Cancel">Cancel</button>
    <button
      type="submit"
      (click)="onSubmit()"
      mat-flat-button matTooltip="Save">
      Save
    </button>
  </mat-toolbar>
</div>
